import { useQuery } from "@tanstack/react-query";
import { getHomeSectionById } from "../../api/apiHomeSections";

export const useGetHomeSectionById = (id) => {
    const { data: homeSection, isLoading, error } = useQuery({
        queryKey: ['home-section', id],
        queryFn: () => getHomeSectionById(id),
        enabled: !!id,
    });

    return { homeSection, isLoading, error };
};
